export const BasicColors = [

    {
        id: "red",
        korean: '빨간색',
        english: 'Red',
        romanization: 'ppalgansaek',
    },
    {
        id: "orange",
        korean: '주황색',
        english: 'Orange',
        romanization: 'juhwangsaek',

    },
                   
                {
        id: "yellow",
        korean: '노란색',
        english: 'Yellow',
        romanization: 'noransaek',

    },
                   
                {
        id: "green",
        korean: '초록색',
        english: 'Green',
        romanization: 'choroksaek',

    },

     {
        id: "blue",
        korean: '파란색',
        english: 'Blue',
        romanization: 'paransaek',

    },
                {
        id: "purple",
        korean: '보라색',
        english: 'Purple',
        romanization: 'borasaek',

    }
]

export const OtherColors = [

 {
        id: "black",
        korean: '검정색',
        english: 'Black',
        romanization: 'geomjeongsaek',

    },
     {
        id: "gray",
        korean: '회색',
        english: 'Gray',
        romanization: 'hoesaek',

    },
     {
        id: "white",
        korean: '하얀색',
        english: 'White',
        romanization: 'hayansaek',

    },
     {
        id: "brown",
        korean: '갈색',
        english: 'Brown',
        romanization: 'galsaek',

    },
         {
        id: "pink",
        korean: '분홍색',
        english: 'Pink',
        romanization: 'bunhongsaek',

    },
         {
        id: "silver",
        korean: '은색',
        english: 'Silver',
        romanization: 'eunsaek',

    },

    {
        id: "gold",
        korean: '금',
        english: 'Gold',
        romanization: 'geum',

    },

];
